<template>
  <div class="right_menu">
    <!-- <img v-if="currentUser.is_login != '0'" :src="'/img/rank/' + currentUser.rank + '.png'" class="rank_icon" @click="page('/my-page')"> -->
    <div class="point_area">
      <div class="login coin">
        <span v-if="currentUser.is_login == '0'" class="pc point_block append_coin" @click="page('/login')">
          0C
        </span>
        <span v-if="currentUser.is_login != '0'" class="pc point_block append_coin"  @click="page('/exchange-card')">
          {{currentUser.coin | commaDecimal}}C
        </span>
      </div>
      <div class="login">
        <span v-if="currentUser.is_login == '0'" class="pc point_block append_gem" @click="page('/login')">
          0Gem
        </span>
        <span v-if="currentUser.is_login != '0'" class="pc point_block append_gem" @click="page('/buy-point')">
          {{currentUser.point | comma}}Gem
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
  separateDecimalNumber,
} from '@/common/util/format';

export default {
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
    commaDecimal(value) {
      return separateDecimalNumber(value);
    },
  },

  methods: {
    page(url) {
      this.$emit('changePage', url);
    },
  },
};
</script>

<style lang="scss" scoped>
.right_menu {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 40px;
  margin-top: 10px;
  .logo {
    width: 200px;
    margin-right: 10px;
  }
  .tokkyo {
    width: 60px;
    margin-right: 10px;
    @media screen and  (max-width: $tabletWidth) {
      width: 32px;
      margin-right: 5px;
    }
  }
  .rank_icon {
    width: 50px;
    margin-right: 10px;
    @media screen and  (max-width: $tabletWidth) {
      width: 32px;
      margin-right: 5px;
    }
  }
  .point_area {
    .login {
      span {
        display: block;
        background-color: $white;
        border-radius: 9px;
        width: 142px;
        height: 30px;
        padding-right: 30px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 5px 0;
      }
    }
  }
  .append_coin {
    background-image: url('/img/coin.png');
    background-repeat: no-repeat; /* 画像を繰り返さない */
    background-position: 5px center; /* 画像を左に配置し、上下を中央揃え */
    background-size: auto 60%; /* 画像のサイズは自動調整 */
  }
  .append_gem {
    background-image: url('/img/gem.png');
    background-repeat: no-repeat; /* 画像を繰り返さない */
    background-position: 7px center; /* 画像を左に配置し、上下を中央揃え */
    background-size: auto 60%; /* 画像のサイズは自動調整 */
  }
}
@media screen and  (max-width: $tabletWidth) {
  .right_menu {
    margin-right: 10px;
    .logo {
      width: 120px;
    }
    .point_area {
      .login {
        span {
          display: block;
          background-color: $white;
          border-radius: 9px;
          width: 92px;
          height: 24px;
          padding-right: 10px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin: 5px 0;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
